export default "__VITE_ASSET__hDFvnam2__"